import { MediaDataTypes } from "@/components/atoms/media/MediaData";
import { CropSize } from "@/types/imageSizing";
import { renderMedia } from "@/utils/renderMediaComponent";
import { Box, chakra, Text } from "@chakra-ui/react";

export interface ImageWithCaptionProps {
  image: MediaDataTypes;
  caption?: string;
  imgAspectRatio?: string;
}

const cropSizes: CropSize[] = [
  {
    alias: "default",
    width: 1920,
    height: 1080,
  },
  {
    alias: "fiveFour",
    width: 1000,
    height: 800,
  },
  {
    alias: "fourFive",
    width: 800,
    height: 1000,
  },
  {
    alias: "square",
    width: 1000,
    height: 1000,
  },
];

export default chakra(ImageWithCaption);
function ImageWithCaption({
  image,
  caption,
  imgAspectRatio = "16:9",
  ...props
}: ImageWithCaptionProps) {
  const getCropSizeAlias = (aspectRatio: string) => {
    switch (aspectRatio) {
      case "5:4":
        return "fiveFour";
      case "4:5":
        return "fourFive";
      case "1:1":
        return "square";
      default:
        return "default";
    }
  };

  const cropSizeAlias = getCropSizeAlias(imgAspectRatio);

  const imageWithCropSizes = {
    ...image,
    cropSizes,
  };

  const media = imageWithCropSizes
    ? renderMedia(imageWithCropSizes, { base: cropSizeAlias }, { base: 1 })
    : undefined;

  return (
    <Box
      sx={{
        "&& iframe": {
          padding: 0,
        },
      }}
    >
      {media}
      {caption && (
        <Text mt={2} textStyle="label.xs" color="gray.600">
          {caption}
        </Text>
      )}
    </Box>
  );
}
